<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-07 11:03:23
-->
<template>
	<div class="product-wrap">
		<el-checkbox-group v-model="checkList" @change="setTableCheckList">
			<div class="card-box">
				<div class="flex-1 flex-row flex-just-center" v-if="!newList.length"><slot name="empty"></slot></div>
				<product-card class="card" @refresh="refresh" v-for="item in newList" :key="item.product_id" :product="item" :checkList="checkList" />
			</div>
		</el-checkbox-group>
	</div>
</template>

<script>
import productCard from './productCard';
import { mapGetters } from 'vuex';
import CopyButtonMixin from '@/components/tableCells/operater/copyLink/mixin';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'productWrap',
	components: {
		productCard,
	},
	mixins: [CopyButtonMixin],
	props: {
		list: {
			type: Array,
			default: _ => [],
		},
	},
	data() {
		return {
			checkList: [],
		};
	},
	computed: {
		...mapGetters(['isDarenPartner']),
		newList() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: {
					label: '复制链接',
					tooltipContent: this.createTooltipContent,
					click: row => this['dyNormalCopy'](row),
				},
				[dataMap.PLATFORM_KS.value]: {
					label: '复制ID',
					tooltipContent: () => '',
					click: row => this['ksCopy'](row),
				},
				[dataMap.PLATFORM_SP.value]: {
					label: '复制链接',
					tooltipContent: () => '',
					click: row => this['spCopy'](row),
				},
			};
			const _list = this.list.map(({ operations, ...rest }) => {
				const _operations = operations.map(item => {
					return item.type === 'copyLink'
						? {
								...item,
								label: temPF[rest.platform_id]?.label || '',
								tooltipContent: temPF[rest.platform_id]?.tooltipContent(rest) || '',
								click: temPF[rest.platform_id]?.click || function () {},
						  }
						: item;
				});
				return {
					...rest,
					operations: _operations,
				};
			});
			return _list;
		},
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		setCheckList(checkList) {
			this.checkList = checkList;
		},
		setTableCheckList(list) {
			const checkList = this.list.filter(({ product_id }) => list.includes(product_id));
			this.$emit('setTableCheckList', checkList, true);
		},
		createTooltipContent(row) {
			// 保持不变
			const isPartnerAuthUrl = +row.source_type === 2 || +row.product_type != 1;
			return this.isDarenPartner
				? isPartnerAuthUrl
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
		refresh(e) {
			this.$emit('refresh', e);
		},
	},
};
</script>

<style lang="less" scoped>
.product-wrap {
	.card-box {
		display: flex;
		flex-wrap: wrap;
		.card {
			margin-top: 24px;
			margin-right: 8px;
		}
	}
}
</style>
